
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.546 44h-9.194c1.787-2.18 2.748-4.733 2.748-7.566 0-1.47-.226-2.566-.678-3.29-1.048-1.68-2.28.435-2.68 1.424-1.117 2.73-2.871 5.53-6.176 5.53-4.297 0-6.378-4.375-6.378-8.108 0-2.677 1.204-5.33 2.817-7.43l8.006-10.517C18.729 11.826 21.025 8.478 23.898 4a129.26 129.26 0 006.922 10.043c2.334 3.028 4.778 5.972 7.053 9.045 2.03 2.743 3.939 5.59 3.939 9.139 0 4.378-3.441 9.118-8.304 7.532-2.27-.74-3.36-3.11-4.25-5.158-.468-1.063-1.582-3.203-2.748-1.424-.43.656-.644 1.753-.644 3.291 0 2.67.892 5.18 2.68 7.532","fill":"#535353"}})])
          )
        }
      }
    